import { documentReady } from "@allwyn/utils/document-ready";
import { HelpCenterAnalytics } from "./hc-analytics";

function initAnalyticsChat() {
    const startChatElement = document.getElementById("hcStartChat");
    const startChatHeaderElement = document.getElementById("hcStartChatHeader");

    if (!startChatElement || !startChatHeaderElement) return;

    startChatElement.addEventListener("click", HelpCenterAnalytics.openAnalyticsChat);
    startChatHeaderElement.addEventListener("click", HelpCenterAnalytics.openAnalyticsChat);
}

documentReady(() => {
    initAnalyticsChat();
});
